"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideMenuItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./SideMenuItem.css");
var SideMenuItem = function (_a) {
    var branch = _a.branch, value = _a.value, item = _a.item, level = _a.level, onClick = _a.onClick;
    return (react_1.default.createElement("li", { className: (0, classnames_1.default)('dui-side-menu-item', "dui-side-menu-item--level-".concat(level), {
            'dui-side-menu-item--active': value === item.id
        }), onClick: function () { return onClick(item.id); } },
        item.label,
        level === 2 && item.children && (react_1.default.createElement("i", { className: (0, classnames_1.default)('dui-side-menu-item__caret dropdown icon', {
                'dui-side-menu-item__caret--open': branch.has(item.id)
            }) }))));
};
exports.SideMenuItem = SideMenuItem;
